(function () {
    'use strict';

    var controllerId = 'shell';
    angular.module('app').controller(controllerId,
        ['$rootScope', 'common', 'config', 'datacontext', 'sectionMenu', '$translate', 'tmhDynamicLocale', shell]);

    function shell($rootScope, common, config, datacontext, sectionMenu, $translate, tmhDynamicLocale) {
        var $location = common.$location;

        var vm = this;
        var logSuccess = common.logger.getLogFn(controllerId, 'success');
        var events = config.events;
        vm.busyMessage = 'Please wait ...';
        vm.isBusy = true;
        vm.spinnerOptions = {
            radius: 40,
            lines: 7,
            length: 0,
            width: 30,
            speed: 1.7,
            corners: 1.0,
            trail: 100,
            color: '#F58A00'
        };
        vm.oggi = new Date();
        vm.currentLanguage = $translate.proposedLanguage() || $translate.use();
        tmhDynamicLocale.set(vm.currentLanguage);

        vm.getSection = sectionMenu.getSection;
        vm.isSectionActive = sectionMenu.isSectionActive;
        vm.getClassIfActive = sectionMenu.getClassIfActive;

        function getUrl(url)
        {
            var n = url.indexOf("#");
            if(n != -1)
            {
                url = url.substring(0, n);
            }
            
            var n = url.lastIndexOf("/");
            if (n != -1) {
                url = url.substring(n);
            }

            return url;
        }

        activate();

        function activate() {            
            var promises = [WhoAmI()];
            common.activateController(promises, controllerId)
                .then(function () {                    
                    var url = $location.absUrl();
                    url = getUrl(url);
                    if (url == "/Ruolo_Super") {
                        $translate.use('it');
                        tmhDynamicLocale.set('it');
                        $location.url("/dashboard_Super");
                    }
                    else if (url == "/Ruolo_Utente") {
                        $location.url("/dashboard_Utente");
                    }                    
                    else if (url == "/Ruolo_Personale") {
                        $location.url("/dashboard_Personale");
                    }
                    else if (url == "/Ruolo_CapoSezione") {
                        $location.url("/dashboard_CapoSezione");
                    }
                });
        }

        function toggleSpinner(on) { vm.isBusy = on; }

        $rootScope.$on('$routeChangeStart',
            function (event, next, current) { toggleSpinner(true); }
        )

        $rootScope.$on(events.controllerActivateSuccess,
            function (event, data) { toggleSpinner(false); }
        )

        $rootScope.$on(events.spinnerToggle,
            function (event, data) { toggleSpinner(data.show); }
        )

        function WhoAmI() {
            return datacontext.getWhoAmI().then(function (data) {  
                $rootScope.userRoles = new Array();
                data.Ruoli.forEach(function (role) {
                    $rootScope.userRoles.push(role.Name);
                });
                $rootScope.id = data.Id;
                $rootScope.name = data.Nominativo;
                $rootScope.username = data.Username;
                $rootScope.email = data.Email;
                $rootScope.statoCV = data.StatoCV;
                $rootScope.azienda = data.Azienda;
                $rootScope.aziendaId = data.AziendaId;
                $rootScope.logo = data.Logo;
                $rootScope.logoReport = data.LogoReport;
                $rootScope.parametriId = data.ParametriId;
                $rootScope.filtroCommesse = data.FiltroCommesse;
                $rootScope.avvisoCV = data.AvvisoCV;
                $rootScope.bSezioni = data.bSezioni;
                $rootScope.filtroSezioni = data.FiltroSezioni;
                $rootScope.basePath = data.BasePath;
                $rootScope.ferie = data.Ferie;

                if (data.Lingua == 'undefined' || !data.Lingua) {
                    $rootScope.lingua = vm.currentLanguage;
                } else {
                    $rootScope.lingua = data.Lingua;
                    $translate.use($rootScope.lingua);
                    vm.currentLanguage = $rootScope.lingua;
                    tmhDynamicLocale.set(vm.currentLanguage);
                }

                //console.info('lingua shell', $rootScope.lingua, data.Lingua);

                return vm.user = data;
            });
        };

        $rootScope.isAuthorized = function (role) {            
            return $rootScope.userRoles != undefined && $rootScope.userRoles != null && $rootScope.userRoles.indexOf(role) !== -1;
        };

        $rootScope.getWhoAmI = WhoAmI;
    };
})();
